import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, invalid, children, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        "w-full px-3 py-2.5 bg-bg-input border rounded-xl text-sm text-text-primary",
        "focus:outline-none focus:ring-1 touch-target appearance-none",
        invalid
          ? "border-danger focus:border-danger focus:ring-danger"
          : "border-border focus:border-accent focus:ring-accent",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  ),
);
Select.displayName = "Select";
